<template>
    <div :class="{'card': isCardStyle}">
        <div :class="{'card-header border-0': isCardStyle}">
            <div class="d-flex align-items-center" :class="classAlignTools">
                <div class="">
                    <h4 class="card-title mb-0" :class="classTitle">{{ $t(itemTitle) }}</h4>
                    <div class="small text-medium-emphasis">{{ $t(itemLabel) }}</div>
                </div>
                <div class="btn-toolbar d-none d-md-block" role="toolbar" aria-label="Toolbar with Buttons">
                    <div v-if="showFilters" class="card-filters btn-group" :class="classTools" role="group" aria-label="Filter Buttons">
                        <button
                            v-for="(btn, idx) in filterButtons"
                            :key="`btn-filter-${idx}`"
                            :class="['btn btn-outline-main min-w-auto', {'active': false}]">
                            {{ $t(btn.name) }}
                        </button>
                    </div>
                    <div v-if="showTools" class="card-tools btn-group" :class="classTools" role="group" aria-label="Tools Buttons">
                        <button v-for="(btn, idx) in toolsButtons"
                            :key="`btn-tool-${idx}`"
                            type="button"
                            :title="$t(btn.title ?? btn.name)"
                            :aria-label="$t(btn.title ?? btn.name)"
                            @click.prevent="btn.fn"
                            data-dismiss="modal"
                            class="btn btn-link btn-tool">
                            <span>
                                <template v-if="btn.name">
                                    {{ $t(btn.name) }}
                                </template>
                                <template v-if="btn.icon">
                                    <i :class="btn.icon"></i>
                                </template>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'card-body': isCardStyle}">
            <div class="row">
                <div class="col-12">
                    <div v-if="hasData" class="chart-wrapper">
                        <!--
                            :style="{
                                'height': `${heightDivChart}px`,
                                'max-height': `${heightDivChart}px`,
                                'margin-top': (showFilters ? '40px' : '')
                            }"
                        -->
                        <component
                            :is="chartComponent"
                            :chartOptions="chartOptions"
                            :chartData="chartData"
                            :chartId="chartId"
                            :datasetIdKey="chartDatasetIdKey"
                            :plugins="chartPlugins"
                            :cssClasses="chartCssClasses"
                            :chartStyle="chartStyle"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                    </div>
                    <div v-else class="alert alert-light text-center" role="alert">
                        {{ notDataInfo }}
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'card-footer': isCardStyle}" v-if="dataFooter.length">
            <div class="row text-center">
                <div class="col mb-sm-2 mb-0 d-flex flex-column justify-content-between"
                    v-for="(fItem, fIdx) in dataFooter"
                    :key="`footer-element-${fIdx}`">
                    <div class="text-medium-emphasis">{{ fItem.label }}</div>
                    <strong>{{ fItem.value }} {{ fItem.percent ? `(${fItem.percent}%)` : '' }}</strong>
                    <div class="progress progress-thin mt-2" precision="1">
                        <div :class="['progress-bar', `bg-${fItem.color}`]"
                            role="progressbar"
                            :aria-valuenow="fItem.percent"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            :style="{'width': `${fItem.percent}%`}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChartComponentMixin from "./mixins/ChartComponentMixin";

export default {
    mixins: [
        ChartComponentMixin,
    ],
    components: {
        LineChart: () => import(/* webpackChunkName: "chart-line" */ '@/app/shared/components/charts/components/Line.vue'),
        BarChart: () => import(/* webpackChunkName: "chart-bar" */ '@/app/shared/components/charts/components/Bar.vue'),
        PieChart: () => import(/* webpackChunkName: "chart-pie" */ '@/app/shared/components/charts/components/Pie.vue'),
    },
    props: {
        showFilters: {
            type: Boolean,
            default: true,
        },
        showTools: {
            type: Boolean,
            default: true,
        },
        alignTools: {
            type: String,
            default: 'right',
            validator: function (value) {
                return ['left', 'center', 'right'].indexOf(value) !== -1
            }
        },
        isCardStyle: {
            type: Boolean,
            default: true,
        },
        classTitle: {
            type: String,
            default: '',
        },
        heightChart: {
            type: Number,
            default: 300,
        },
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    computed: {
        chartLabel() {
            return moment().format('MMMM YYYY');
        },
        chartOptions() {
            let options = this.chartConfig?.options ?? {};
            let defaultBarOptions = {
                scales: {
                    x: {
                        grid: {
                            drawOnChartArea: !1
                        }
                    },
                    y: {
                        ticks: {
                            beginAtZero: !0,
                            maxTicksLimit: 5,
                            // stepSize: Math.ceil(50),
                            // max: 250
                        }
                    }
                },
                elements: {
                    line: {
                        tension: .4
                    },
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                },
                plugins: {
                    title: {
                        display: !1
                    },
                    legend: {
                        display: !1
                    }
                },
            };
            return {
                ...{
                    responsive: true,
                    maintainAspectRatio: false,
                },
                ...options
            };
        },
        heightDivChart() {
            return this.heightChart;
        },
        chartStyle() {
            return {
                height: `${this.heightDivChart}px`,
                width: '100%',
                position: 'relative',
            }
        },
        filterButtons() {
            return [
                {
                    key: 'day',
                    name: 'Dia',
                    fn: () => {},
                },
                {
                    key: 'month',
                    name: 'Mês',
                    fn: () => {},
                },
                {
                    key: 'year',
                    name: 'Ano',
                    fn: () => {},
                }
            ];
        },
        toolsButtons() {
            let tools = [];
            if(this.allowExport) {
                tools.push({
                    title: 'global.export',
                    icon: 'fas fa-download',
                    fn: (event) => {this.$emit(`tool`, {key: 'export'})},
                });
            }
            return tools;
        },
        dataFooter() {
            return this.itemFooter?.data ?? [];
        },
        classAlignTools() {
            switch (this.alignTools) {
                case 'left':
                    return 'justify-content-start';
                case 'center':
                    return 'justify-content-center';
                case 'right':
                    return 'justify-content-between';
                default:
                    break;
            }
        },
        classTools() {
            switch (this.alignTools) {
                case 'left':
                    return 'float-left ml-3';
                case 'center':
                    return 'float-none mx-3';
                case 'right':
                    return 'float-right mr-3';
                default:
                    break;
            }
        }
    },
    methods: {

    },
    watch: {

    }
}
</script>

<style scoped lang="scss">
.card-tools {
    .btn-tool {
        min-width: auto;
        box-shadow: none;
        padding: 0;
        font-size: 1rem;
    }
}
</style>